if (!customElements.get('media-card-tabs-showcase')) {
  class MediaCardTabsShowcase extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;

      this.tabs = [...this.querySelectorAll('[data-showcase-tab]')];
      this.panels = [...this.querySelectorAll('[data-showcase-panel]')];
      this.dots = [...this.querySelectorAll('[data-showcase-dot]')];
      this.previousButton = this.querySelector('[data-showcase-previous]');
      this.nextButton = this.querySelector('[data-showcase-next]');
      this.stage = this.querySelector('[data-showcase-stage]');
      if (!this.tabs.length || this.tabs.length !== this.panels.length) return;

      this.index = 0;
      this.handleClickBound = this.handleClick.bind(this);
      this.handleKeydownBound = this.handleKeydown.bind(this);
      this.handleBlockSelectBound = this.handleBlockSelect.bind(this);
      this.handleTouchStartBound = this.handleTouchStart.bind(this);
      this.handleTouchEndBound = this.handleTouchEnd.bind(this);

      this.addEventListener('click', this.handleClickBound);
      this.addEventListener('keydown', this.handleKeydownBound);
      this.addEventListener('shopify:block:select', this.handleBlockSelectBound);
      this.stage?.addEventListener('touchstart', this.handleTouchStartBound, { passive: true });
      this.stage?.addEventListener('touchend', this.handleTouchEndBound, { passive: true });
      this.ready = true;
      this.show(0, false, false);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClickBound);
      this.removeEventListener('keydown', this.handleKeydownBound);
      this.removeEventListener('shopify:block:select', this.handleBlockSelectBound);
      this.stage?.removeEventListener('touchstart', this.handleTouchStartBound);
      this.stage?.removeEventListener('touchend', this.handleTouchEndBound);
      this.ready = false;
    }

    show(index, focusTab = false, scrollTab = true) {
      if (index < 0 || index >= this.panels.length) return;
      this.index = index;

      this.tabs.forEach((tab, tabIndex) => {
        const active = tabIndex === index;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
      });
      this.panels.forEach((panel, panelIndex) => {
        panel.hidden = panelIndex !== index;
      });
      this.dots.forEach((dot, dotIndex) => {
        const active = dotIndex === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', String(active));
      });

      // 到达首尾时禁用对应按钮，切换不会从末尾回到开头。
      if (this.previousButton) this.previousButton.disabled = index === 0;
      if (this.nextButton) this.nextButton.disabled = index === this.panels.length - 1;
      if (scrollTab) this.tabs[index].scrollIntoView({ block: 'nearest', inline: 'nearest' });
      if (focusTab) this.tabs[index].focus();
    }

    handleClick(event) {
      const target = event.target instanceof Element ? event.target : null;
      if (!target) return;

      const tab = target.closest('[data-showcase-tab]');
      const dot = target.closest('[data-showcase-dot]');
      if (tab && this.contains(tab)) this.show(Number(tab.dataset.index));
      else if (dot && this.contains(dot)) this.show(Number(dot.dataset.index));
      else if (target.closest('[data-showcase-previous]')) this.show(this.index - 1);
      else if (target.closest('[data-showcase-next]')) this.show(this.index + 1);
    }

    handleKeydown(event) {
      const tab = event.target instanceof Element ? event.target.closest('[data-showcase-tab]') : null;
      if (!tab || !this.contains(tab)) return;

      let nextIndex;
      if (event.key === 'ArrowRight') nextIndex = Math.min(this.index + 1, this.tabs.length - 1);
      else if (event.key === 'ArrowLeft') nextIndex = Math.max(this.index - 1, 0);
      else if (event.key === 'Home') nextIndex = 0;
      else if (event.key === 'End') nextIndex = this.tabs.length - 1;
      else return;

      event.preventDefault();
      this.show(nextIndex, true);
    }

    handleBlockSelect(event) {
      const panel = event.target instanceof Element ? event.target.closest('[data-showcase-panel]') : null;
      if (panel && this.contains(panel)) this.show(Number(panel.dataset.index));
    }

    handleTouchStart(event) {
      if (!window.matchMedia('(max-width: 768px)').matches) return;
      const touch = event.changedTouches[0];
      this.touchStart = { x: touch.clientX, y: touch.clientY };
    }

    handleTouchEnd(event) {
      if (!this.touchStart) return;
      const touch = event.changedTouches[0];
      const deltaX = touch.clientX - this.touchStart.x;
      const deltaY = touch.clientY - this.touchStart.y;
      this.touchStart = null;
      if (Math.abs(deltaX) < 45 || Math.abs(deltaX) < Math.abs(deltaY) * 1.25) return;
      this.show(this.index + (deltaX < 0 ? 1 : -1));
    }
  }

  customElements.define('media-card-tabs-showcase', MediaCardTabsShowcase);
}
